import React from 'react'

import {
  IProps as ILegalSection,
  LegalSection,
  IMarkdown,
} from 'marketing-site/src/library/components/LegalSection'

import {
  ILegalSection as IContentfulLegalSection,
  IMarkdown as IContentfulMarkdown,
} from 'marketing-site/@types/generated/contentful'

import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export const ContentfulLegalSection = (legalSection: IContentfulLegalSection) => (
  <EntryMarker entry={legalSection}>
    {() => <LegalSection {...transformLegalSection(legalSection)} />}
  </EntryMarker>
)

export function transformLegalSection({ fields }: IContentfulLegalSection): ILegalSection {
  const transformedData: ILegalSection = {
    ...fields,
    effectiveDate: fields.effectiveDate && getFormattedDateFromContentful(fields.effectiveDate),
    content: fields.content.map((md: IContentfulMarkdown) => transformMarkdown(md)),
  }
  return transformedData
}

export function transformMarkdown({ fields }: IContentfulMarkdown): IMarkdown {
  return {
    ...fields,
  }
}

const getFormattedDateFromContentful = (date: string) => {
  const [year, month, day] = date.split('T')[0].split('-')
  const monthList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  return `${+day} ${monthList[+month - 1]} ${+year}`
}
